import data from './chapter-videos.json';

export type VideoMeta = {
  title: string;
  slug: string;
  durationSeconds: number;
  youtubeId: string | null;
  thumbnail: string;
  uploadDate: string;
};

type Store = {
  channel: { name: string; url: string };
  videos: Record<string, VideoMeta>;
  chapterToVideo: Record<string, string>;
};

const s = data as unknown as Store;

export function useChapterVideo(chapterId: string | undefined): VideoMeta | null {
  if (!chapterId) return null;
  const key = s.chapterToVideo[chapterId];
  if (!key) return null;
  return s.videos[key] ?? null;
}

export function getChannel() {
  return s.channel;
}

/** ISO 8601 duration string for VideoObject JSON-LD. */
export function isoDuration(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const sec = Math.round(seconds % 60);
  return `PT${m}M${sec}S`;
}
